import SideNavigation, {
  SideNavigationProps,
} from '@amzn/awsui-components-react/polaris/side-navigation';
import * as React from 'react';

/** Sentinel href used to intercept the Oncall Dashboard nav click in onFollow. */
const ONCALL_DASHBOARD_HREF = '#oncall-ticket-dashboard';
/** QuickSight dashboard id for the on-call ticket dashboard. */
const ONCALL_DASHBOARD_ID = 'oncall-ticket-dashboard';

export const navItems: ReadonlyArray<SideNavigationProps.Item> = [
  {
    type: 'link',
    text: 'Ops Tumbler',
    href: '/',
  },
  {
    type: 'divider',
  },
  {
    type: 'section',
    text: 'OpenSearch Serverless',
    items: [
      { type: 'link', text: 'OpenSearch Serverless', href: '/juno' },
      { type: 'link', text: 'Logs', href: '/juno/log' },
    ],
  },
  {
    type: 'divider',
  },
  {
    type: 'section',
    text: 'LSE Tool',
    items: [
      { type: 'link', text: 'Create New Impact Analysis', href: '/lse-tool' },
    ],
  },
  {
    type: 'divider',
  },
  {
    type: 'section',
    text: 'Ops Transparency',
    items: [
      { type: 'link', text: 'Onboarding', href: '/ops-transparency' },
      { type: 'link', text: 'Onboarded', href: '/ops-transparency/onboarded' },
      {
        type: 'link',
        text: 'Verify All',
        href: '/ops-transparency/verify/all',
      },
      {
        type: 'link',
        text: 'Verify Actionable All',
        href: '/ops-transparency/verify/actionable/all',
      },
    ],
  },
  {
    type: 'divider',
  },
  {
    type: 'section',
    text: 'SDPDS',
    items: [
      { type: 'link', text: 'Component Release Tracker', href: '/component-release-tracker' },
      { type: 'link', text: 'Software Update Tracker', href: '/software-update-tracker' },
    ],
  },
  {
    type: 'divider',
  },
  {
    type: 'section',
    text: 'Integration',
    items: [
      { type: 'link', text: 'DataSources', href: '/integration' },
      { type: 'link', text: 'Query Explorer', href: '/integration/query-explorer' },
      { type: 'link', text: 'Index Explorer', href: '/integration/index-explorer' },
    ],
  },
  {
    type: 'divider',
  },
  {
    type: 'link',
    text: 'Audit History',
    href: '/audit-history',
  },
  {
    type: 'link',
    text: 'Oncall Dashboard',
    href: ONCALL_DASHBOARD_HREF,
  },
];

const Sidebar = (props) => {
  const [activeHref, setActiveHref] = React.useState('#/');

  const openOncallDashboard = async () => {
    // Open the tab synchronously inside the click handler so the browser does
    // not block it as a popup; redirect it to the embed URL once ready.
    const win = window.open('', '_blank');
    try {
      const resp = await fetch('/api/quicksight/embed-url', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ dashboardId: ONCALL_DASHBOARD_ID }),
      });
      if (!resp.ok) {
        throw new Error(`embed-url request failed: ${resp.status}`);
      }
      const data = await resp.json();
      const url = data && data.embedUrl;
      if (url && win) {
        win.location.href = url;
      } else if (win) {
        win.close();
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to generate QuickSight embed URL', error);
      if (win) {
        win.close();
      }
    }
  };

  return (
    <SideNavigation
      activeHref={activeHref}
      header={{ href: '', text: 'Ops Tools' }}
      onFollow={(event) => {
        if (event.detail.href === ONCALL_DASHBOARD_HREF) {
          event.preventDefault();
          openOncallDashboard();
          return;
        }
        if (!event.detail.external) {
          setActiveHref(event.detail.href);
        }
      }}
      items={navItems}
    />
  );
};

export { Sidebar };
